import {gsap} from "gsap";

export class Seat {

    constructor(props) {
        this.props = props;

        this.available = props.data.available;

        this.iconpath = props.iconpath;
        this.rotate = props.rotate;
        this.skey = props.data.skey;
        this.seatKey = props.data.skey;
        this.row = props.data.row;
        this.num = parseInt(props.data.skey.split('/')[2]);

        if (props.data.oitems != null) {
            this.tooltip = props.data.oitems.toString();
        }

        this.el = document.createElementNS("http://www.w3.org/2000/svg", "g");
        const svgSeat = document.createElementNS("http://www.w3.org/2000/svg", "path");
        this.clickArea = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        this.clickArea.setAttributeNS(null, 'fill', "transparent");
        this.clickArea.setAttributeNS(null, 'cx', 0);
        this.clickArea.setAttributeNS(null, 'cy', 0);
        this.clickArea.setAttributeNS(null, 'r', '12');
        this.clickArea.setAttributeNS(null, 'opacity', 0.2);
        this.clickArea.setAttributeNS(null, 'stroke', "transparent");

        const svgCross = document.createElementNS("http://www.w3.org/2000/svg", "path");
        svgCross.setAttribute("d", "M18.32.38l-18,15m0-15,18,15");
        svgCross.setAttribute("class", "cross");
        svgCross.setAttributeNS(null, 'transform', "translate(-9,-9)");


        switch (this.iconpath) {
            case "circle":
                svgSeat.setAttribute("d", "M 0,0 m -10, 0 a 10, 10 0 1,0 20,0 a 10,10 0 1,0 -20,0"); //Set path's data        
                svgSeat.setAttributeNS(null, 'fill', "transparent");
                break;

            default:
                svgSeat.setAttribute("d", "M -6.38 3.4 l 13.2 0 m 1.62 1 V -1.26 M -8.5 4.43 S -8.5 6.5 0 6.5 s 8.47 -2.07 8.47 -2.07 M -8.5 -1.26 v 5.69 M 6.85 -0.74 H 9 M -8.5 -0.74 H -6.38 m 12.7 4.65 V -6 A 9.59 9.59 0 0 0 -6.51 -6 l 0.13 10"); //Set path's data
                svgSeat.setAttributeNS(null, 'transform', "rotate(" + this.rotate + ")");
                break;

        }

        this.radius = 12;
        this.x = this.props.leftMargin + 18 + parseInt((this.props.data.x - this.props.offset.x) - (this.radius * .5));
        this.y = this.props.topMargin + 18 + parseInt((this.props.data.y - this.props.offset.y) - (this.radius * .5));

        this.el.setAttribute("cx", this.x);
        this.el.setAttribute("cy", this.y);
        this.el.setAttributeNS(null, 'transform', "translate(" + this.x + "," + this.y + ")");

        this.el.setAttribute("class", "seat");
        this.el.setAttribute("id", this.seatKey.replace(/\//g, "-"));
        this.el.setAttribute("data-id", this.seatKey);
        this.el.appendChild(this.clickArea);

        this.el.appendChild(svgSeat);
        this.el.appendChild(svgCross);

        if (this.tooltip != "") {
            this.el.setAttribute("title", this.tooltip);
        }

        $('.section-seats').append(this.el);

        this.radius = "10";

        this._render();
    }

    isSelected() {
        return $(this.el).hasClass('picked');
    }

    isAvailableForSeating() {
        return !$(this.el).hasClass('notAvailableForSeating');
    }

    hover() {
        gsap.killTweensOf(this.el);
        $(this.el).addClass('hover');
    }

    clearHover() {
        gsap.killTweensOf(this.el);
        $(this.el).removeClass('hover');
        $(this.el).removeClass('notAvailableForSeating');
    }

    notAvailableForSeating() {
        gsap.killTweensOf(this.el);
        $(this.el).addClass('notAvailableForSeating');
    }

    picked() {
        gsap.killTweensOf(this.el);
        this.selected = true;
        $(this.el).addClass('picked');
        $(this.el).removeClass('err');
    }

    active() {
        gsap.killTweensOf(this.el);
        $(this.el).removeClass('picked');
        $(this.el).addClass('active');
        $(this.el).removeClass('err');
    }


    // Already taken seats
    unavailable() {
        gsap.killTweensOf(this.el);
        this.available = false;
        $(this.el).addClass('unavailable');
        $(this.el).removeClass('picked');
        $(this.el).removeClass('err');
    }

    loading() {
        gsap.killTweensOf(this.el);
        $(this.el).addClass('loading');
        $(this.el).removeClass('err');
    }

    unpicked() {
        gsap.killTweensOf(this.el);
        $(this.el).removeClass('picked');
        $(this.el).removeClass('err');
    }

    error() {
        let spot = $(this.el);
        gsap.killTweensOf(this.el);

        spot.addClass('err');
        gsap.to(this.el, 2.3, {
            className: '+=unavailable', onComplete: function () {
                spot.removeClass('err');
                spot.unbind();
            }
        });
    }

    getRadius() {
        return this.radius;
    }

    _render() {

        this.el.setAttribute("cx", this.x);
        this.el.setAttribute("cy", this.y);

        if (!this.available) {
            $(this.el).addClass('unavailable');
        }
    }
}